import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

// Teach tailwind-merge the named z-index scale from tailwind.config.js so
// `cn("z-overlay", "z-sheet")` resolves to the last one instead of keeping both.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      z: [{ z: ["sticky", "fab", "tabbar", "overlay", "sheet", "popover", "toast", "tour", "max"] }],
    },
  },
});

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
